import { lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { UserAuthProvider } from '@/contexts/UserAuthContext';
import { SystemConfigProvider } from '@/contexts/SystemConfigContext';
import UserProtectedRoute from '@/components/billing/UserProtectedRoute';

const PortalLogin = lazy(() => import('@/pages/portal/Login'));
const PortalDashboard = lazy(() => import('@/pages/portal/Dashboard'));
const PortalInvoices = lazy(() => import('@/pages/portal/Invoices'));
const PortalProfile = lazy(() => import('@/pages/portal/Profile'));
const PortalOnboarding = lazy(() => import('@/pages/portal/Onboarding'));
const PortalInvoicing = lazy(() => import('@/pages/portal/Invoicing'));
const PortalVerifyWhatsApp = lazy(() => import('@/pages/portal/VerifyWhatsApp'));
const PortalForgotPassword = lazy(() => import('@/pages/portal/ForgotPassword'));
const PortalUpload = lazy(() => import('@/pages/portal/PortalUpload'));

export function PortalRoutes() {
  return (
    <UserAuthProvider>
      <SystemConfigProvider>
        <Routes>
          <Route path="login" element={<PortalLogin />} />
          <Route path="forgot-password" element={<PortalForgotPassword />} />
          <Route
            path="onboarding"
            element={<UserProtectedRoute><PortalOnboarding /></UserProtectedRoute>}
          />
          <Route
            path="dashboard"
            element={<UserProtectedRoute requiresOnboarding><PortalDashboard /></UserProtectedRoute>}
          />
          <Route
            path="invoices"
            element={<UserProtectedRoute requiresOnboarding><PortalInvoices /></UserProtectedRoute>}
          />
          <Route
            path="profile"
            element={<UserProtectedRoute requiresOnboarding><PortalProfile /></UserProtectedRoute>}
          />
          <Route
            path="facturacion"
            element={<UserProtectedRoute requiresOnboarding><PortalInvoicing /></UserProtectedRoute>}
          />
          <Route
            path="upload"
            element={<UserProtectedRoute requiresOnboarding><PortalUpload /></UserProtectedRoute>}
          />
          <Route
            path="verify-whatsapp"
            element={<UserProtectedRoute><PortalVerifyWhatsApp /></UserProtectedRoute>}
          />
          <Route path="" element={<Navigate to="/portal/login" replace />} />
        </Routes>
      </SystemConfigProvider>
    </UserAuthProvider>
  );
}
